// extracted by mini-css-extract-plugin
export var emailform = "NewsletterForm-module--emailform--9ce56";
export var newsletterformbody = "NewsletterForm-module--newsletterformbody--ddd47";
export var newsletterformtitle = "NewsletterForm-module--newsletterformtitle--d7486";
export var newsletterformwrapper = "NewsletterForm-module--newsletterformwrapper--8b6fd";
export var signuplink = "NewsletterForm-module--signuplink--41382";